var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInformationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11.968,
    r: 11,
    fill: "#C8615E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.27481 11.0857C9.27481 10.198 9.98898 9.47839 10.8699 9.47839C11.7509 9.47839 12.4651 10.198 12.4651 11.0857L12.4651 18.1066C12.4651 18.9943 11.7509 19.7139 10.8699 19.7139C9.98898 19.7139 9.27481 18.9943 9.27481 18.1066L9.27481 11.0857Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9262 8.14909C11.2815 8.15117 11.6295 8.04769 11.926 7.85177C12.2225 7.65585 12.4541 7.37631 12.5916 7.0486C12.729 6.72088 12.766 6.35973 12.698 6.01094C12.6299 5.66214 12.4599 5.34141 12.2093 5.08939C11.9588 4.83737 11.639 4.66541 11.2906 4.59532C10.9423 4.52522 10.5809 4.56014 10.2524 4.69565C9.92386 4.83116 9.64297 5.06116 9.44532 5.35649C9.24766 5.65182 9.14215 5.99919 9.14214 6.35456C9.14137 6.82892 9.32874 7.28423 9.66318 7.62064C9.99762 7.95704 10.4518 8.14709 10.9262 8.14909Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationIcon);
export default __webpack_public_path__ + "static/media/information-icon.e9a164d0a173d8d4e201457d54a8a9d1.svg";
export { ForwardRef as ReactComponent };